import { TYPES } from './action';

const { UPDATE } = TYPES;

const initialState = {
  email: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        ...action.state,
      };
    default:
      return state;
  }
};
